
import React, { useState } from "react";
import SimpleBar from 'simplebar-react';
import { useLocation } from "react-router-dom";
import { CSSTransition } from 'react-transition-group';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignOutAlt, faTimes, faNewspaper, faBookOpen, faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { Nav, Badge, Image, Button, Accordion, Navbar } from '@themesberg/react-bootstrap';
import { Link } from 'react-router-dom';

import { Routes } from "../routes";
import ProfilePicture from "../assets/img/team/profile-picture-3.jpg";

const BrandLogo = process.env.PUBLIC_URL + '/logo.png';

export default (props = {}) => {
  const location = useLocation();
  const { pathname } = location;
  const [show, setShow] = useState(false);
  const showClass = show ? "show" : "";
  
  const localStorageContracted = () => {
    return localStorage.getItem('sidebarContracted') === 'true' ? true : false;
  }
  const [contracted, setContracted] = useState(localStorageContracted());
  React.useEffect(() => {
    if (contracted) {
      document.body.classList.add('sidebar-contracted');
    } else {
      document.body.classList.remove('sidebar-contracted');
    }
  }, [contracted]);
  const contractedClass = contracted ? "contracted" : "";

  const onCollapse = () => setShow(!show);
  
  const toggleContracted = () => {
    setContracted(!contracted);
    localStorage.setItem('sidebarContracted', !contracted);
  };

  const CollapsableNavItem = (props) => {
    const { eventKey, title, icon, children = null } = props;
    const defaultKey = pathname.indexOf(eventKey) !== -1 ? eventKey : "";

    return (
      <Accordion as={Nav.Item} defaultActiveKey={defaultKey}>
        <Accordion.Item eventKey={eventKey}>
          <Accordion.Button as={Nav.Link} className="d-flex justify-content-between align-items-center">
            <span>
              {icon ? <span className="sidebar-icon"><FontAwesomeIcon icon={icon} /> </span> : null}
              <span className="sidebar-text">{title}</span>
            </span>
          </Accordion.Button>
          <Accordion.Body className="multi-level">
            <Nav className="flex-column">
              {children}
            </Nav>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    );
  };

  const NavItem = (props) => {
    const { title, link, external, target, icon, image, badgeText, badgeBg = "secondary", badgeColor = "primary" } = props;
    const classNames = badgeText ? "d-flex justify-content-start align-items-center justify-content-between" : "";
    const navItemClassName = link === pathname ? "active" : "";
    const linkProps = external ? { href: link } : { as: Link, to: link };

    return (
      <Nav.Item className={navItemClassName} onClick={() => setShow(false)}>
        <Nav.Link {...linkProps} target={target} className={classNames}>
          <span>
            {icon ? <span className="sidebar-icon"><FontAwesomeIcon icon={icon} /> </span> : null}
            {image ? <Image src={image} width={20} height={20} className="sidebar-icon svg-icon" /> : null}

            <span className="sidebar-text">{title}</span>
          </span>
          {badgeText ? (
            <Badge pill bg={badgeBg} text={badgeColor} className="badge-md notification-count ms-2">{badgeText}</Badge>
          ) : null}
        </Nav.Link>
      </Nav.Item>
    );
  };

  return (
    <>
      <Navbar expand={false} collapseOnSelect variant="dark" className="navbar-theme-primary px-4 d-md-none">
        <Navbar.Brand className="me-lg-5" as={Link} to={Routes.DashboardOverview.path}>
          <Image src={BrandLogo} className="navbar-brand-light" style={{ height: '35px', objectFit: 'contain' }} />
        </Navbar.Brand>
        <Navbar.Toggle as={Button} aria-controls="main-navbar" onClick={onCollapse}>
          <span className="navbar-toggler-icon" />
        </Navbar.Toggle>
      </Navbar>

      <div 
        className="d-none d-md-flex align-items-center justify-content-center"
        onClick={toggleContracted}
        style={{
          position: 'fixed',
          left: contracted ? '0px' : '260px',
          top: '50%',
          transform: 'translate(-50%, -50%)',
          width: '28px',
          height: '28px',
          backgroundColor: '#1f2937', 
          color: '#ffffff',
          borderRadius: '50%',
          cursor: 'pointer',
          zIndex: 1050,
          transition: 'left 0.3s ease',
          boxShadow: '0 2px 5px rgba(0,0,0,0.3)',
          border: '1px solid #374151'
        }}
        title={contracted ? "Menüyü Genişlet" : "Menüyü Daralt"}
      >
        <FontAwesomeIcon icon={contracted ? faChevronRight : faChevronLeft} size="xs" />
      </div>

      <CSSTransition timeout={300} in={show} classNames="sidebar-transition">
        <SimpleBar className={`collapse ${showClass} ${contractedClass} sidebar d-md-block bg-primary text-white`}>
          <div className="sidebar-inner px-4 pt-3">
            <div className="user-card d-flex d-md-none align-items-center justify-content-between justify-content-md-center pb-4">
              <div className="d-flex align-items-center">
                <div className="user-avatar lg-avatar me-4">
                  <Image src={ProfilePicture} className="card-img-top rounded-circle border-white" />
                </div>
                <div className="d-block">
                  <h6>Hi, Jane</h6>
                  <Button as={Link} variant="secondary" size="xs" to={Routes.Signin.path} className="text-dark">
                    <FontAwesomeIcon icon={faSignOutAlt} className="me-2" /> Sign Out
                  </Button>
                </div>
              </div>
              <Nav.Link className="collapse-close d-md-none" onClick={onCollapse}>
                <FontAwesomeIcon icon={faTimes} />
              </Nav.Link>
            </div>
            <Nav className="flex-column pt-3 pt-md-0">
              <Nav.Item className="d-none d-md-block mb-3">
                <Nav.Link as={Link} to={Routes.DashboardOverview.path} className="d-flex align-items-center">
                  <Image src={BrandLogo} style={{ height: '35px', objectFit: 'contain' }} />
                  <span className="ms-2 fw-bold fs-5 text-white">Jigogo</span>
                </Nav.Link>
              </Nav.Item>
              <NavItem title="Anasayfa" link={Routes.DashboardOverview.path} />


              <CollapsableNavItem eventKey="accounts/" title="Hesaplar">
                <NavItem title="Ekle" link={Routes.AccountsAdd.path} />
                <NavItem title="Listele" link={Routes.AccountsList.path} />
                <NavItem title="Like List" link={Routes.LikeList.path} />
                <NavItem title="Şehir Kümesi" link={Routes.CityClusters.path} />
              </CollapsableNavItem>

              <NavItem title="Admin Mesajları (JİGOGO)" link={Routes.AdminMessages.path} />
              <NavItem title="Toplu Mesaj Gönder" link={Routes.BulkMessageSend.path} />
              <NavItem title="Hızlı Cevapsız Mesajlar" link={Routes.QuickUnreplied.path} />
              <NavItem title="Tüm Mesajlar" link={Routes.AllMessages.path} />
              <NavItem title="Hızlı Mesajlar" link={Routes.QuickMessagesManage.path} />

              <CollapsableNavItem eventKey="social/" title="Sosyal" icon={faNewspaper}>
                <NavItem title="Gönderiler" link={Routes.PostsList.path} icon={faNewspaper} />
                <NavItem title="Hikayeler" link={Routes.StoriesList.path} icon={faBookOpen} />
                <NavItem title="Reels" link={Routes.ReelsList.path} icon={faNewspaper} />
                <NavItem title="Yorumlar" link={Routes.CommentsList.path} icon={faNewspaper} />
              </CollapsableNavItem>

              <NavItem title="Kredi Paketleri" link={Routes.CreditPackages.path} />
              <NavItem title="Vip Paketleri" link={Routes.VipPackages.path} />
              <NavItem title="VIP İstatistikleri" link={Routes.VipStatistics.path} />
              <NavItem title="Ödeme Hataları" link={Routes.BillingErrors.path} />

              <NavItem title="Üyeler" link={Routes.MembersList.path} />

              <CollapsableNavItem eventKey="notifications/" title="Bildirimler">
                <NavItem title="Anlık Bildirimler" link={Routes.Notifications.path} />
                <NavItem title="Fotoğraflı Bildirim" link={Routes.PhotoNotification.path} />
              </CollapsableNavItem>

              <NavItem title="Değerlendirmeler" link={Routes.Evaluations.path} />

              <NavItem title="Talepler" link={Routes.ContactRequests.path} />

              <NavItem title="Uygulama Ayarları" link={Routes.AppSettings.path} />
              <NavItem title="Arşiv" link={Routes.Archive.path} />
            </Nav>
          </div>
        </SimpleBar>
      </CSSTransition>
    </>
  );
};
